import React from 'react'
import { Link } from "react-router-dom";
import { FaFacebook } from "react-icons/fa";
import { BsTwitter } from "react-icons/bs";
import { BsInstagram } from "react-icons/bs";
import { BsLinkedin } from "react-icons/bs";
import { FiMail } from "react-icons/fi";
export const Newfooter = () => {
  return (
    <>
    <footer className="max-w-full bg-cyan-400  h-1/5 md:flex px-30 py-10  justify-between">
      <div className="md:flex md:flex-col justify-between pl-10  ">
        <h2 className="text-black text-3xl pl-10 font-Montserrat font-bold underline">
          Fabrik
        </h2>
        <ul className="mb-8 space-y-2 text-sm list-none mt-5">
          <div className="md:flex md:flex-row space-x-5  justify-between pl-10">
            <li>
              <Link className="hover:text-white text-gray-800 text-base" to="/">
                Home
              </Link>
            </li>
            <li>
              <Link className="hover:text-white text-gray-800 text-base" to="/">
                Services
              </Link>
            </li>
            <li>
              <Link className="hover:text-white text-gray-800 text-base" to="/">
                Team
              </Link>
            </li>
            <li>
              <Link className="hover:text-white text-gray-800 text-base" to="/">
                Contact
              </Link>
            </li>
            <li>
              <Link className="hover:text-white text-gray-800 text-base" to="/">
                Blog
              </Link>
            </li>
          </div>
        </ul>
      </div>
      <div className="md:flex md:flex-col content-center justify-items-center">
        <h2 className="text-black font-Montserrat mx-auto font-semibold text-xl">Follow Us</h2>
        <div className="md:flex md:flex-row content-center justify-items-center">
          <div className=" mr-4 py-4">
            <a href="">
              {" "}
              <FaFacebook color="black" size={30} />
            </a>
          </div>
          <div className="px-4 py-4">
            <a href="">
              <BsTwitter color="black" size={30} />
            </a>
          </div>
          <div className="px-4 py-4">
            <a href="">
              {" "}
              <BsInstagram color="black" size={30} />
            </a>
          </div>
          <div className="px-4 py-4">
            <a href="">
              {" "}
              <BsLinkedin color="black" size={30} />
            </a>
          </div>
          <div className="px-4 py-4">
            <a href="">
              {" "}
              <FiMail color="black" size={30} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  </>
  )
}
